/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type Defect_status = "ACCEPTED" | "IDENTIFIED" | "IN_REVIEW" | "REJECTED" | "RESOLVED" | "%future added value";
export type Inspection_status = "ARCHIVED" | "COMPLETED" | "DRAFT" | "IN_PROGRESS" | "%future added value";
export type Severity = "CRITICAL" | "HIGH" | "LOW" | "MEDIUM" | "%future added value";
export type Submission_status = "COMPLETED" | "FAILED" | "PENDING" | "PROCESSING" | "%future added value";
export type TourPreview_tour = {
    readonly id: string;
    readonly thumbnailURL: string;
    readonly title: string;
    readonly viewingSessionRequest: {
        readonly rtcToken: string;
        readonly signalingToken: string;
        readonly appId: string;
        readonly viewingSessionUserId: number;
        readonly expireTime: number;
    };
    readonly inspections: ReadonlyArray<{
        readonly id: string;
        readonly title: string;
        readonly inspectionStatus: Inspection_status;
        readonly inspectionDate: unknown;
        readonly propertyAddress: string;
        readonly inspectorName: string;
        readonly defects: ReadonlyArray<{
            readonly id: string;
            readonly title: string;
            readonly description: string;
            readonly severity: Severity;
            readonly defectStatus: Defect_status;
            readonly roomType: string;
            readonly defectCategory: string;
            readonly sourceClipIndex: number;
            readonly sourceFramePosition: string;
            readonly aiDetected: boolean;
            readonly aiConfidence: number;
            readonly evidenceImageURI: string;
            readonly audioStartSeconds: number;
            readonly audioEndSeconds: number;
        }>;
        readonly audioSubmissions: ReadonlyArray<{
            readonly id: string;
            readonly videoURI: string;
            readonly originalFilename: string;
            readonly submissionStatus: Submission_status;
            readonly rawTranscript: string;
            readonly durationSeconds: number;
            readonly errorMessage: string;
            readonly createdAt: unknown;
        }>;
    }>;
    readonly clips: ReadonlyArray<{
        readonly id: string;
        readonly index: number;
        readonly frameCount: number;
    }>;
    readonly " $fragmentRefs": FragmentRefs<"TourPreviewMarkers_tour" | "TourPlayerCanvas_tour">;
    readonly " $refType": "TourPreview_tour";
};
export type TourPreview_tour$data = TourPreview_tour;
export type TourPreview_tour$key = {
    readonly " $data"?: TourPreview_tour$data;
    readonly " $fragmentRefs": FragmentRefs<"TourPreview_tour">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./TourPreviewTodoRefetchQuery.graphql.ts'),
      "identifierField": "id"
    }
  },
  "name": "TourPreview_tour",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "thumbnailURL",
      "storageKey": null
    },
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ViewingSessionRequest",
      "kind": "LinkedField",
      "name": "viewingSessionRequest",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "rtcToken",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "signalingToken",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "appId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "viewingSessionUserId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "expireTime",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PropertyInspection",
      "kind": "LinkedField",
      "name": "inspections",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "inspectionStatus",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "inspectionDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "propertyAddress",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "inspectorName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DefectItem",
          "kind": "LinkedField",
          "name": "defects",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "description",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "severity",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "defectStatus",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "roomType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "defectCategory",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "sourceClipIndex",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "sourceFramePosition",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "aiDetected",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "aiConfidence",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "evidenceImageURI",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "audioStartSeconds",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "audioEndSeconds",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "InspectionAudioSubmission",
          "kind": "LinkedField",
          "name": "audioSubmissions",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "videoURI",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "originalFilename",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "submissionStatus",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "rawTranscript",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "durationSeconds",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "errorMessage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdAt",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Clip",
      "kind": "LinkedField",
      "name": "clips",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "index",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "frameCount",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TourPreviewMarkers_tour"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TourPlayerCanvas_tour"
    }
  ],
  "type": "Tour",
  "abstractKey": null
};
})();
(node as any).hash = 'e75e1b970e6c0bb4665c6f7c1305b93c';
export default node;
